import {get} from 'lodash';
import axios from '../services/axios';
import {getIcon, getPriority, getMenuSearchDataByQueryParams} from '../helpers/productHelper.js';
import {FilterApi} from './filter-api';
import {setInfiniteScroll, fetchProducts, fetchProductsComplete} from './product';
import {HINTS_URL} from '../config/api';
import {setPickupAddresses} from '../reducers/addressReducer';
import {SET_CATEGORIES, setMaintenance, toBool} from '../reducers/configReducer';
import {setUser} from '../reducers/userReducer';
import {authFormDataHeader, getValidToken} from '../services/getValidToken';
import {getDeliveryOptionsRequest} from '../services';
import * as types from './types';
import {DEFAULT_CENTER_LAT, DEFAULT_CENTER_LNG} from '../config/global';
import {getPlaceDetails} from './address';
import {
  deliveryRadiusSelector,
  isOrderingHours,
  isSalesChannelNameProvided,
  isSalesChannelFulfillmentMethodOn,
  isRootSalesChannelEnabled,
} from '../selectors/configSelectors';
import {getQueryParams} from '../selectors/uri_selectors';
import {getPickupAddresses, isAllowedAddressByZip, isForbiddenAddressByZip} from '../selectors/address';
import {getZipCode} from '../components/AddressAutocomplete/utils';
import {
  getMenuByType, getMenuByTypeAndProductId, searchMenu, searchSuggestions, searchProducts
} from '../helpers/api';
import { getTenantId, getUserId } from '../helpers/tenant';
import {setLastPage, allowNewRequest, resetLazyLoader, nextPage, setLastKey} from "./lazyload";
import { setFilterParams, setAdvancedFilterOpenInitialValue } from '../reducers/filterReducer';
import { FILTER_CATEGORY_ID } from '../const/filter_const';
import { getSalesChannelName, getFulfillmentTypes, getMenuQueryParameter } from '../selectors/sales_channel_selectors';
import { saveShippingOptions } from './sales_channel_actions';
import {getSelectedCustomerType, isStrictMedicalCustomerType} from "../selectors/customer_type_selector";
import { showLoader, hideLoader } from '../helpers/loader';
import { setLayoutView } from '../reducers/viewReducer';
import { kioskModeType, ACH_PROVIDER_JS_LIBRARY_URL } from '../config/const';
import { useScript } from '../helpers/dom_util';
import {updateCustomerType} from "./customer_type_actions";
import {setCustomerTypeQueryParameter} from "../services/uri";
export const SET_ACTIVE_CATEGORY_INDEX = 'SET_ACTIVE_CATEGORY_INDEX';

const MobileDetect = require('mobile-detect');

export function setCurrentCategoryIndex(index) {
  return {type: 'SET_CURRENT_CATEGORY_INDEX', payload: index};
}

export function setActiveCategoryIndex(index) {
  return {type: SET_ACTIVE_CATEGORY_INDEX, payload: index};
}

export const SET_CHANGING_CATEGORY = 'SET_CHANGING_CATEGORY';
function setChangingCategory(state) {
  return {type: SET_CHANGING_CATEGORY, payload: state};
}

function setFetchingProducts(state) {
  return {type: 'SET_FETCHING_DATA', payload: state};
}

function setProducts(data) {
  return {type: 'SET_PRODUCTS', payload: data};
}

function concatProducts(data) {
  return {type: 'CONCAT_PRODUCTS', payload: data};
}

export const setConfig = (data) => {
  return {type: 'SET_CONFIG', payload: data};
}

export const setCategories = (data) => {
  return {type: SET_CATEGORIES, payload: data};
}

export const setDeliveryOptions = (options) => ({
  type: types.SET_DELIVERY_OPTIONS,
  options
});

const getCategories = categories => {
  const _categories = categories.map((category, index) => ({
    name: category.name,
    customerTypes: category.customerTypes,
    id: index,
    icon: getIcon(category.name),
    priority: getPriority(category.name),
    isHidden: false
  }));
  _categories.sort((a, b) => a.priority - b.priority);
  return _categories;
};

export const fetchCategories = () => (dispatch, getState) => {
  const queryParam = getMenuQueryParameter(getState());
  const uri = `${HINTS_URL}/HintsService/v1.0/rest/ecommerce/config?${queryParam}`;

  showLoader();

  return axios.get(uri).then(response => {
    if (
      response.data.resultCode === 'SUCCESS'
    ) {
      const config = response.data.data;
      dispatch(setCategories(getCategories(config.categories)));
    }
  })
  .catch(e => console.error(e))
  .then(() => hideLoader());
}

function loadScripts(configs) {
  const achProviderJsLibraryUrl = configs[ACH_PROVIDER_JS_LIBRARY_URL];
  useScript(achProviderJsLibraryUrl);
}

export function bootstrapApp(kioskMode) {
  return (dispatch, getState) => {
    const queryParam = getMenuQueryParameter(getState());
    const uri = `${HINTS_URL}/HintsService/v1.0/rest/ecommerce/config?${queryParam}`;

    return axios.get(uri).then(
      response => {
        if (
          !!!response ||
          !!!response.data ||
          response.data.resultCode === 'FAIL' ||
          !response.data.data ||
          isMenuDisabled(response.data.data)
        ) {
          dispatch(setMaintenance(true));
          return;
        }

        const config = response.data.data;
        const isAdvancedFilterOpened = toBool(getAdvancedFilterOpenDefaultValue(config));
        const _categories = getCategories(config.categories);
        // check mobile or pc
        const md = new MobileDetect(window.navigator.userAgent);
        const _config = {
          ...config,
          isEcommerceEnabled:
            (isRootSalesChannelEnabled({config}) || isSalesChannelNameProvided(getState())) ? isSalesChannelFulfillmentMethodOn({config}) : true
            && isOrderingHours(config)
            && (
              toBool(config.ECOMMERCE_TYPE_INSTORE) ||
              toBool(config.ECOMMERCE_TYPE_DELIVERY) ||
              toBool(config.ECOMMERCE_TYPE_EXPRESS)
            ),
          categories: _categories,
          configFetched: true,
          isPhone: !!md.phone() || !!md.tablet(),
          is_iPhone: md.is('iPhone') || md.is('tablet'),
        };
        const pickupAddresses = config.pickupAddresses.map(addr => ({dispensaryName: addr.name, address: addr}));
        dispatch(setPickupAddresses(pickupAddresses));
        dispatch(setConfig(_config));
        dispatch(setMaintenance(false));
        dispatch(setLayoutView(getDefaultLayoutView(config)));
        dispatch(setAdvancedFilterOpenInitialValue(kioskMode === kioskModeType.ONLINE_MENU && isAdvancedFilterOpened));
        loadScripts(_config)
      },
      error => {
        dispatch(setMaintenance(true));
      }
    );
  }
  };

export function filterByState() {
  return (dispatch, getState) => {
    const filterParams = { ...getState().filter.filterParams };
    dispatch(filter(filterParams));
  };
}

export function startFilter(filterParams) {
  return (dispatch) => {
    dispatch(setInfiniteScroll(true));
    dispatch(resetLazyLoader());
    dispatch(nextPage());
    dispatch(filter(filterParams));
  };
}

export function filter(filterParams) {
  return (dispatch, getState) => {
    const { lazyLoad } = getState();
    const filterParamsWithSalesChannelName = {
      ...filterParams,
      salesChannelName: getSalesChannelName(getState()),
      customerType: getSelectedCustomerType(getState())
    };
    const data = {
      dataObject: filterParamsWithSalesChannelName,
      tenantId: getTenantId(),
      userId: getUserId(),
    };
    dispatch(setFetchingProducts(true));
    data.dataObject.page = lazyLoad.currentPage;
    showLoader();
    axios
      .post(searchMenu(), data)
      .then(response => {
        const productList = get(response, 'data.productGrouplist', []);
        const totalPages = get(response, 'data.totalPages', 0);
        const newData = {
          menuSize: productList.length,
          totalPages,
          productGrouplist: productList
        };
        const data = {
          data: newData,
          category: 'filter'
        };
        if (productList.length === 0 || totalPages - 1 === lazyLoad.currentPage) {
          dispatch(setInfiniteScroll(false));
          dispatch(setLastPage(true));
        }
        dispatch(setFetchingProducts(false));
        dispatch(setFilterParams(filterParams));
        dispatch(allowNewRequest());
        if (lazyLoad.currentPage > 0) {
          dispatch(concatProducts(data));
        } else {
          dispatch(setProducts(data));
        }
      })
      .catch(error => {
        hideLoader();
        console.log(error);
      })
      .then(() => {
        hideLoader();
      });
  };
}

export function getSearchSuggestions(searchString, customerType, salesChannelName, strictMedicalCustomerType) {
  const data = {
    tenantId: getTenantId(),
    userId: getUserId(),
    salesChannelName,
    strictMedicalCustomerType,
  };

  return axios
    .post(searchSuggestions(searchString, customerType, 25), data)
}

export async function validateLicenseAndViolationBan(customerId) {
  const token = await getValidToken();

  return axios
    .post(
      `${HINTS_URL}/HintsService/v1.0/rest/ecommerce/customer/${customerId}/validateLicenseAndViolationBan`,
      {},
      authFormDataHeader(token)
    )
}

// fetch products by id. get all product till searched id + 5 more
export function fetchByProductsById(catName, productId) {
  return (dispatch, getState) => {
    const url = getFetchProductByIdUrl(catName, productId, getState());

    return axios
      .get(url)
      .then(response => {
        const data = {
          data: response.data,
          category: catName
        };
        dispatch(concatProducts(data));
        hideLoader();
        return response.data;
      });
  };
}

export function getProductsById(catName, productId, customerType) {
  return (dispatch, getState) => {
    const url = getMenuByTypeAndProductId(getTenantId(), getUserId(), catName, productId, getMenuQueryParameter(getState(), customerType));

    return axios
      .get(url)
      .then(response => {
        return response.data;
      });
  }
}

/* fetch by category name with pagination and and concat to existing */
export const fetchMoreByState = (limit) => (dispatch, getState) => {
  showLoader();
  const {products, config, lazyLoad} = getState();

  const categories = config.categories;
  const selectedCategory = products.currentCategoryIndex;

  if (selectedCategory === FILTER_CATEGORY_ID) {
    dispatch(filterByState());
    return;
  }

  const categoryName = get(categories, selectedCategory +'.name', 'flower');
  const currentPage = lazyLoad.currentPage;
  const selectedCategoryIndex = getState().config.categories.findIndex((cat, index) => cat.name.toLowerCase() === categoryName.toLowerCase());
  dispatch(setCurrentCategoryIndex(selectedCategoryIndex));
  dispatch(fetchMoreByCategory(categoryName, currentPage, limit))
};

export function fetchMoreByCategory(categoryName, offset, limit) {
  showLoader();
  return (dispatch, getState) => {
    const url = getFetchCategoryUrl(categoryName, offset, limit, getState());
    axios
      .get(url)
      .then((response) => {
        const data = {
          data: response.data,
          category: categoryName,
        };
        dispatch(concatProducts(data));
        if (data.data.metaData) {
          dispatch(saveShippingOptions(data.data.metaData));
        }
        if (get(data.data, 'totalPages', 0) === offset || get(data.data, 'productGrouplist', []).length === 0) {
          dispatch(setLastPage(true));
        }
        dispatch(allowNewRequest());
        dispatch(fetchProductsComplete());
      })
      .catch((error) => {
        console.error(error);
        dispatch(allowNewRequest());
        hideLoader();
      });
  };
}

const getFetchCategoryUrl = (categoryName, offset, limit, state) => {
  return getMenuByType(
    getTenantId(),
    getUserId(),
    categoryName,
    offset,
    limit,
    getMenuQueryParameter(state),
  );
};

const getFetchProductByIdUrl = (categoryName, productId, state) => {
  return getMenuByTypeAndProductId(getTenantId(), getUserId(), categoryName, productId, getMenuQueryParameter(state));
};

/* fetch by cat and create a new products array */
export function fetchByCategory(categoryName, offset, limit) {
  return (dispatch, getState) => {
    const state = getState();
    const url = getFetchCategoryUrl(categoryName, offset, limit, state);
    dispatch(setChangingCategory(true));
    dispatch(setFetchingProducts(true));
    dispatch(setInfiniteScroll(true));
    showLoader();
    return axios
      .get(url)
      .then(response => {
        const data = {
          data: response.data,
          category: categoryName
        };
        if (data.data.metaData) {
          dispatch(saveShippingOptions(data.data.metaData));
        }
        dispatch(setProducts(data));
        dispatch(setChangingCategory(false));
        dispatch(setFetchingProducts(false));
        dispatch(allowNewRequest());
        if (get(data.data, 'totalPages', 0) === offset || get(data.data, 'productGrouplist', []).length === 0) {
          dispatch(setLastPage(true));
        }
      }).catch(e => {
        console.error(e);
      });
  };
}

export function fetchBySearch(limit) {
  return (dispatch, getState) => {
    const state = getState();
    const { lazyLoad } = state;
    const queryParams = getQueryParams(state);
    const url = searchProducts(queryParams.query || '', getSelectedCustomerType(state), limit);
    const data = getMenuSearchDataByQueryParams(queryParams, isStrictMedicalCustomerType(state), getTenantId(), getUserId());

    if (lazyLoad.lastKey) {
      data.afterKey = lazyLoad.lastKey;
    }
    showLoader();
    dispatch(setFetchingProducts(true));

    axios
      .post(url, data)
      .then((response) => {
        const data = {
          data: {
            productGrouplist: response.data.data
          },
          lastKey: response.data.lastKey
        };

        dispatch(concatProducts(data));
        dispatch(setLastKey(data.lastKey));

        if (data.data.productGrouplist.length < limit) {
          dispatch(setLastPage(true));
        }

        stopFetchingProducts(dispatch);
      })
      .catch((error) => {
        stopFetchingProducts(dispatch);
      });
  };
}

const stopFetchingProducts = (dispatch) => {
  dispatch(allowNewRequest());
  dispatch(setFetchingProducts(false));
  hideLoader();
}

export function changeUserType(type) {
  return async dispatch => {
    const token = await getValidToken();
    return axios
      .post(
        `${HINTS_URL}/HintsService/v1.0/rest/ecommerce/customer/type/${type}/`,
        {},
        authFormDataHeader(token)
      )
      .then(response => {
        dispatch(setUser({customerType: type}));
        dispatch(updateCustomerType(type));
        setCustomerTypeQueryParameter(type);
      });
  };
}

const isMenuDisabled = data => data.MENU_ENABLED === '0';

const getDefaultLayoutView = configObj => {
  return configObj.DEFAULT_ECOMMERCE_LAYOUT_VIEW;
}

const getAdvancedFilterOpenDefaultValue = configObj => {
  return configObj.ADVANCED_FILTER_OPEN_VALUE;
}
/**
 * Fetches new deliveryAddress options from the server and updates the state
 * @returns {function(*): Promise<T | void>}
 */
export const fetchAndUpdateDeliveryOptions = () => (dispatch) => getDeliveryOptionsRequest()
  .then(options => dispatch(setDeliveryOptions(options)))
  .catch(err => console.log(err));

export const checkIsCorrectDeliveryAddress = (placeId = '') => (dispatch, getState) => {
  if (!placeId) {
    return Promise.resolve(false);
  }

  return getPlaceDetails(placeId)
    .then(res => get(res, 'data.results', [])[0])
    .then(place => {
      if (!place) {
        console.log('Address not found by Google');
        return Promise.resolve(false);
      }

      const state = getState();
      const zip = getZipCode(place);

      return isAllowedAddressByZip(state, zip)
        ? true : isForbiddenAddressByZip(state, zip)
          ? false : isAddressInRadius(state, place);
    })
    .catch(e => console.log(e));
};

export const isAddressInRadius = (state, googlePlace) => {
  try {
    const radius = deliveryRadiusSelector(state);

    // radius center
    const pickupAddress = getPickupAddresses(state)[0];
    const centerLat = pickupAddress.address.latitude || DEFAULT_CENTER_LAT;
    const centerLng = pickupAddress.address.longitude || DEFAULT_CENTER_LNG;

    // target place
    const placeLng = googlePlace.geometry.location.lng;
    const placeLat = googlePlace.geometry.location.lat;

    const distance = window.google.maps.geometry.spherical.computeDistanceBetween(
      new window.google.maps.LatLng(centerLat, centerLng), new window.google.maps.LatLng(placeLat, placeLng)
    );

    return distance <= radius;
  } catch (e) {
    console.log(e);
  }
};

export const sendPurchaseConversion = (saleValue, orderId) => {
  const uri = `https://insight.adsrvr.org/track/conv/?adv=efj5q1x&ct=0:5kayo70&fmt=3v=${saleValue}&orderid=${orderId}`;

  httpGet(uri)
};

export const httpGet = (theUrl) => {
  try {
    var xmlHttp = new XMLHttpRequest();
    xmlHttp.open( "GET", theUrl, false );
    xmlHttp.send( null );
    return xmlHttp.responseText;
  } catch(e) {
    console.error(e);
  }
};



// WEBPACK FOOTER //
// ./src/actions/api.js